import React, { useCallback } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';

import DataTypeChecker from 'redpoints-model-js-common/DataTypeChecker';
import ShortenerLink from 'redpoints-model-js/model/system/ShortenerLink';

import {
  Col,
  Info,
  Input,
  Paper,
  Row,
  Spin,
} from 'redpoints-front-components/index';
import {
  NoResult,
  PriorityTag,
  withQueryParams,
} from 'redpoints-front-common/components';

import { shortenerResolutionSetTargetLinks } from '../../../actions/shortenerResolutionActions';
import {
  getShortenerResolutionActionsAreLoading,
  getShortenerResolutionFiltersSelected,
  getShortenerResolutionLinkToResolve,
  getShortenerResolutionLinkToResolveIsLoading,
  getShortenerResolutionNoMoreLinksToResolve,
  getShortenerResolutionSelectedTargetLink,
} from '../../../reducers/tasks/shortenerResolution';
import ShortenerResolutionActions from './ShortenerResolutionActions';
import NoFilterApplied from '../../../components/NoFilterApplied';
import { translate } from '../../../helpers/languageHelper';

const ShortenerResolutionLinkToResolve = ({
  actionsAreLoading,
  linkToResolve,
  linkToResolveIsLoading,
  noMoreLinksToResolve,
  queryParams,
  shortenerResolutionSetTargetLinks,
  targetLink,
}) => {
  const handleInputChange = useCallback(
    event => {
      const targetLink = event.target.value;
      shortenerResolutionSetTargetLinks({ targetLink });
    },
    [shortenerResolutionSetTargetLinks]
  );

  const areFiltersApplied = Object.keys(queryParams).length > 0;
  if (!areFiltersApplied) {
    return (
      <NoFilterApplied
        title={translate('common.no_filter')}
        description={translate('common.no_filter_description')}
      />
    );
  }

  if (noMoreLinksToResolve) {
    return (
      <NoResult
        text={translate('common.no_more_results')}
        subtext={translate('common.enjoy')}
      />
    );
  }

  return (
    <Spin spinning={linkToResolveIsLoading}>
      <div className="rp-shortener-resolution-wrapper">
        <Paper>
          {DataTypeChecker.isClass(linkToResolve, ShortenerLink) && (
            <>
              <Row type="flex" gutter={48}>
                <Col lg={24}>
                  <div className="rp-shortener-resolution-item-wrapper">
                    <Info
                      label={translate(
                        'tasks.shortenerResolution.linkToResolve.label'
                      )}
                      value={
                        <a
                          href={linkToResolve.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="rp-shortener-resolution-wrapper-link-to-resolve"
                        >
                          {linkToResolve.url}
                        </a>
                      }
                    />
                    <PriorityTag priority={linkToResolve.priority} />
                  </div>
                </Col>
              </Row>
              <Row type="flex" gutter={48}>
                <Col lg={24}>
                  <div className="rp-shortener-resolution-item-wrapper">
                    <Input
                      aria-label="target-link"
                      label={translate(
                        'tasks.shortenerResolution.targetLink.label'
                      )}
                      onChange={handleInputChange}
                      value={targetLink}
                      disabled={actionsAreLoading}
                    />
                  </div>
                </Col>
              </Row>
              <Row type="flex" gutter={48}>
                <Col lg={24}>
                  <ShortenerResolutionActions />
                </Col>
              </Row>
            </>
          )}
        </Paper>
      </div>
    </Spin>
  );
};

const mapStateToProps = state => ({
  actionsAreLoading: getShortenerResolutionActionsAreLoading(state),
  filtersSelected: getShortenerResolutionFiltersSelected(state),
  linkToResolve: getShortenerResolutionLinkToResolve(state),
  linkToResolveIsLoading: getShortenerResolutionLinkToResolveIsLoading(state),
  noMoreLinksToResolve: getShortenerResolutionNoMoreLinksToResolve(state),
  targetLink: getShortenerResolutionSelectedTargetLink(state),
});

export default compose(
  connect(mapStateToProps, {
    shortenerResolutionSetTargetLinks,
  }),
  withQueryParams
)(ShortenerResolutionLinkToResolve);
